import { AccordionHeaderCombinedProps } from './types';

const usePresenter = (props: AccordionHeaderCombinedProps): AccordionHeaderCombinedProps => {
  return props;
};

export default usePresenter;
